import { callApiWithAuthorization } from "../CallApi";

export async function getEntityPages(entityId, portalId="") {
    const request = await callApiWithAuthorization(`/api/v0/display/entity/${entityId}/pages?portalId=${portalId}`);
    const response = await request.json();
    return response;
}

export async function getPage(pageId) {
    const request = await callApiWithAuthorization(`/api/v0/display/pages/${pageId}`);
    const response = await request.json();
    return response;
}

export async function createPage(entityId, pageProperties) {
    const request = await callApiWithAuthorization(`/api/v0/display/entity/${entityId}/pages`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            pageProperties
        })
    });
    const response = await request.json();
    return response;
}

export async function updatePage(pageId, pageProperties) {
    const request = await callApiWithAuthorization(`/api/v0/display/page/${pageId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            pageProperties
        })
    });
    const response = await request.json();
    return response;
}

export async function createComponent(pageId, parentComponentId, entityName, properties) {
    const request = await callApiWithAuthorization(`/api/v0/display/page/${pageId}/components`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            parentComponentId,
            entityName,
            properties
        })
    });
    const response = await request.json();
    return response;
}

export async function updateComponent(pageId, componentId, properties) {
    const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            properties
        })
    });
    const response = await request.json();
    return response;
}

export async function deleteComponent(pageId, componentId) {
    const request = await callApiWithAuthorization(`/api/v0/display/page/${pageId}/components/${componentId}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        }
    });
    const response = await request.json();
    return response;
}

export async function resetComponent(pageId, componentId, entityName) {
    const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}/reset`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            entityName
        })
    });
    const response = await request.json();
    return response;
}

export async function createAction(pageId, componentId, parentId, action) {
    const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}/actions`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            parentId,
            action
        })
    });
    const response = await request.json();
    return response;
}

export async function deleteAction(pageId, componentId, parentId, actionId) {
    const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}/action/${actionId}?parentId=${parentId}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        }
    });
    const response = await request.json();
    return response;
}

export async function updateAction(pageId, componentId, parentId, actionId, properties) {
    const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}/action/${actionId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            parentId,
            properties
        })
    });
    const response = await request.json();
    return response;
}

export async function getComponentsOfTypeWithPageDataOfEntity(entityId, componentType) {
    const request = await callApiWithAuthorization(`/api/v0/entity/${entityId}/page-components?componentType=${componentType}`);
    const response = await request.json();
    return response;
}

export async function getComponentsWithAttributesSyncedTo(componentId) {
    const request = await callApiWithAuthorization(`/api/v0/component/${componentId}/synced-components`);
    const response = await request.json();
    return response;
}

export async function syncGroupAttributesWithComponents(pageId, componentId) {
    await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}/sync-group-attributes`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        }
    });
}

export async function syncViewAttributesWithComponents(pageId, componentId) {
    await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}/sync-form-attributes`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        }
    });
}

export async function getReferenceAttributeEntityPages(attributeId, portalId) {
    let request = await callApiWithAuthorization("/api/v0/display/page-by-reference-attribute?attributeId=" + attributeId + "&portalId=" + portalId);
    let result = await request.json();
    return result
};

export async function toggleComponentHiddenState(pageId, componentId) {
    const request = await callApiWithAuthorization(`/api/v0/page/${pageId}/component/${componentId}/hidden`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        }
    });
    const response = await request.json();
    return response;
}

export async function updateDatePropertiesRelatedToGanttChart(attributeId, setDefaultDate, defaultDateDifference) {
    const request = await callApiWithAuthorization(`/api/v0/gantt-chart/${attributeId}/update-dates`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            setDefaultDate,
            defaultDateDifference
        })
    });
    const response = await request.json();
    return response;
}